/**
 * Production
 */
// export const BASE_URL = "https://aakashgangaopen.xyz/";
// export const BASE_APP = "https://aakashgangaopen.xyz";
// export const SERVER_URL = "https://aakashgangaopen.xyz";

// export const BASE_URL = import.meta.env.VITE_BASE_URL
// export const BASE_APP = import.meta.env.VITE_BASE_APP
// export const SERVER_URL = import.meta.env.VITE_SERVER_URL

export const BASE_URL = process.env.REACT_APP_BASE_URL
export const BASE_APP = process.env.REACT_APP_BASE_APP
export const SERVER_URL = process.env.REACT_APP_SERVER_URL


/**
 * Development
 */
// export const BASE_URL = "http://localhost:8000/";
// export const BASE_APP = "http://localhost:8000";
// export const SERVER_URL = "http://localhost:8000";


/**
 * Staging
 */
// export const BASE_URL = 'http://159.65.153.60/'
// export const BASE_APP = 'http://159.65.153.60'
// export const SERVER_URL = "http://159.65.153.60"

// export const BASE_URL = 'http://13.126.168.170:8001'
// export const BASE_APP = 'http://13.126.168.170:8001'
// export const SERVER_URL = "http://13.126.168.170:8001"

// export const BASE_URL = 'http://3.109.142.88:6000/'
// export const BASE_APP = 'http://3.109.142.88'
// export const SERVER_URL = "http://3.109.142.88"

